export function AddMonths(date: Date, delta: number) {
	const d = new Date(date);
	d.setMonth(d.getMonth() + delta);
	return d;
}
export function DatesAreSame(a: Date, b: Date) {
	return a.getFullYear() === b.getFullYear()
		&& a.getMonth() === b.getMonth()
		&& a.getDate() === b.getDate();
}
export function FirstDayOfMonth(date: Date) {
	return new Date(date.getFullYear(), date.getMonth(), 1);
}
export function LastDayOfMonth(date: Date) {
	return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}
export function ToISOString(d: Date) {
	const y = d.getFullYear();
	const m = String(d.getMonth() + 1).padStart(2, "0");
	const day = String(d.getDate()).padStart(2, "0");
	return `${y}-${m}-${day}`;
}